<div
  class="breadcrumb-container"
  *ngIf="hoverMenuesService.helpMenuStatus"
  [style.left.px]="calcOffset()"
  [style.top]="this.heightReference + 'px'"
>
  <div class="breadcrumb">
    <div class="breadcrumb-item row">
      <button class="clean-button-style" (click)="goToUserManual()" >
        <div class="icon"><img alt src="assets/img/draft.svg" /></div>
        <div class="font-style-user-manual">{{ 'AppComponent.UserManual' | translate }}</div>
      </button>
    </div>
    <div class="breadcrumb-item row">
      <div class="version">
        <div class="version-icon"><mat-icon style="font-size: 24px">bookmark</mat-icon></div>
        <div class="font-style-user-manual" style="margin-top: 2px">
          {{ ('AppComponent.Version' | translate) + ': ' + version }}
        </div>
      </div>
    </div>
  </div>
</div>
